import React from 'react';
import {Form} from 'antd';
import {AssignmentRounded, DescriptionRounded, EditRounded, MenuBookRounded, PlayCircleRounded, QuizRounded, SearchRounded, SportsEsportsRounded} from '@mui/icons-material';
import BlockIcon from '../../components/BlockIcon';
import ResourceCard from '../../components/ResourceCard';

const RESOURCES = [
    { key: 'textbookContent', icon: <BlockIcon icon={<MenuBookRounded />} />,      label: 'Examples',                   description: 'Worked examples and explanations from the textbook' },
    { key: 'exercise',        icon: <BlockIcon icon={<EditRounded />} />,           label: 'Exercise',                   description: 'Structured practice exercises from the textbook' },
    { key: 'questions',       icon: <BlockIcon icon={<QuizRounded />} />,           label: 'Questions',                  description: 'Individual practice questions' },
    { key: 'quiz',            icon: <BlockIcon icon={<AssignmentRounded />} />,     label: 'Quiz',                       description: 'Short knowledge-check quizzes' },
    { key: 'walkthroughs',    icon: <BlockIcon icon={<SearchRounded />} />,         label: 'Walkthroughs',               description: 'Interactive step-by-step guides' },
    { key: 'extras',          icon: <BlockIcon icon={<SportsEsportsRounded />} />,  label: 'Scorcher, Desmos and Games', description: 'Extension challenges and interactive activities' },
    { key: 'videos',          icon: <BlockIcon icon={<PlayCircleRounded />} />,     label: 'Videos',                     description: 'Lesson explainer videos' },
    { key: 'worksheets',      icon: <BlockIcon icon={<DescriptionRounded />} />,    label: 'Worksheets',                 description: 'Printable worksheets for classwork or homework' },
];

const ChooseResources = () => {
    return (
        <div>
            <h2>Choose your resources</h2>
            <p className="ch-lesson-planner-step-subtitle">
                Select the types of content to include in the lesson plan.
            </p>
            <div
                className="ch-lesson-planner-resource-grid"
                role="group"
                aria-label="Resource types"
            >
                {RESOURCES.map(resource => (
                    <Form.Item
                        key={resource.key}
                        name={['selectedResources', resource.key]}
                        valuePropName="checked"
                        noStyle
                    >
                        <ResourceCard resource={resource} />
                    </Form.Item>
                ))}
            </div>
        </div>
    );
};

export default ChooseResources;
